document.addEventListener('DOMContentLoaded', () => {
  const init = () => {
    const section = document.querySelector('[data-partners-parallax]');
    if (!section) return;

    const cards = section.querySelectorAll('[data-pp-card]');

    // 1. Card fade-in entrance
    cards.forEach((card) => {
      gsap.fromTo(
        card,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: card,
            start: 'top bottom-=100',
            once: true,
          },
        }
      );

    });

    // 3. Stacking cards animation — separate pin from scale
    const cardWrappers = gsap.utils.toArray('[data-card-wrapper]', section);
    const cardElements = gsap.utils.toArray('[data-pp-card]', section);

    if (cardWrappers.length === 0) return;

    if (!window.matchMedia('(max-width: 749px)').matches) {
      const listEl = section.querySelector('[data-partners-list]');

      cardWrappers.forEach((wrapper, i) => {
        const card = cardElements[i];
        const isLast = i === cardWrappers.length - 1;
        let scale = 1, rotation = 0;
        if (i !== cardWrappers.length - 1) {
          scale = 0.9 + 0.025 * i;
          rotation = -10;
        }
        wrapper.style.zIndex = i + 1;
        gsap.to(card, {
          scale,
          rotationX: rotation,
          transformOrigin: 'top center',
          ease: 'none',
          scrollTrigger: {
            trigger: wrapper,
            start: 'top ' + (60 + 10 * i),
            end: 'bottom 550',
            endTrigger: listEl,
            scrub: 1,
            pin: wrapper,
            pinSpacing: isLast,
            id: 'pp-pin-scale-' + (i + 1),
            invalidateOnRefresh: true,
          },
        });
      });
    }

    ScrollTrigger.refresh();
  };

  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);
    init();
  } else {
    const interval = setInterval(() => {
      if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
        clearInterval(interval);
        gsap.registerPlugin(ScrollTrigger);
        init();
      }
    }, 50);
  }

  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('[data-partners-parallax]')) {
      ScrollTrigger.getAll().filter(st => st.vars.id?.startsWith('pp-')).forEach(st => st.kill());
      init();
    }
  });
});
